const AUTO_ENTER_EXHIBITS_KEY = 'humanmuseum.preferences.autoEnterExhibits.v1'

/** Read the opt-in preference synchronously; storage access is optional in restricted browser contexts. */
export function loadAutoEnterExhibits(): boolean {
  try {
    const value = globalThis.localStorage?.getItem(AUTO_ENTER_EXHIBITS_KEY)
    if (value === null || value === undefined) return false
    const parsed: unknown = JSON.parse(value)
    return parsed === true
  } catch {
    return false
  }
}

export function saveAutoEnterExhibits(enabled: boolean): void {
  try {
    globalThis.localStorage?.setItem(AUTO_ENTER_EXHIBITS_KEY, JSON.stringify(enabled))
  } catch {
    // Preference storage must never interfere with the visit itself.
  }
}
